import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { ShieldCheck } from 'lucide-react';
export function FinalCTA() {
  return <SectionWrapper className="bg-brand-darker border-t border-gray-800" data-id="element-34">
      <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-35">
        <h2 className="text-4xl md:text-5xl font-display uppercase mb-6" data-id="element-36">
          Tu familia merece{' '}
          <span className="text-brand-green" data-id="element-37">esa aprobación</span>
        </h2>
        <p className="text-xl text-gray-400 mb-10 max-w-2xl mx-auto" data-id="element-38">
          Deja de perder oportunidades por errores del pasado. Toma el control
          de tu reporte hoy mismo.
        </p>
        <div className="flex items-center justify-center gap-2 text-sm text-gray-400" data-id="element-39">
          <ShieldCheck className="w-4 h-4 text-brand-green" data-id="element-40" />
          <span data-id="element-41">Acceso inmediato tras la compra. Pago seguro y privado.</span>
        </div>
      </div>
    </SectionWrapper>;
}